import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { TerminalHoldStatusModal } from 'components/modules/shipments/TerminalHoldStatusModal';
export const TerminalHoldStatusEditor = forwardRef(({ stopEditing, data, node }, ref) => {
    /**
     * data has shipment details, extracting only required one
     */
    const { shipment_oid, terminal_hold_status } = data;
    /**
     * Required state for holding existing data
     */
    const [open, setOpen] = useState(true);
    const [value, setValue] = useState(terminal_hold_status || []);
    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return value;
            },
        };
    });
    /**
     * Handle after success
     */
    function handleSuccess(payload) {
        const update = (payload === null || payload === void 0 ? void 0 : payload.terminal_hold_status) || [];
        setValue(update);
        node.updateData(Object.assign(Object.assign({}, data), update));
        stopEditing();
        setOpen(false);
    }
    /**
     * Once modal closed
     */
    function handleHide() {
        stopEditing();
        setOpen(false);
    }
    return (React.createElement(TerminalHoldStatusModal, { open: open, onHide: handleHide, onSuccess: handleSuccess, shipmentId: shipment_oid }));
});
